var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.producer))]),_vm._v(" unassigned station from "),_c('strong',[_vm._v(_vm._s(_vm.source))]),_vm._v(" organization. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }